import React from 'react';
import { CheckCircle, Download } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { TaskStatus } from '@/types/productFeed';
import SubTask from '@/components/SubTask';
import DownloadReportField from '@/components/DownloadReportField';

interface Step9CompletionProps {
  vendor?: string;
  onBackToHome: () => void;
  stepNineTasks?: TaskStatus;
}


const Step9Completion: React.FC<Step9CompletionProps> = ({
  vendor,
  onBackToHome,
  stepNineTasks
}) => {
  const subTasks = stepNineTasks?.subTasks || [];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Sub Tasks Section */}

      <SubTask subTasks={subTasks} />

      {/* Status Section */}
      <Card className="bg-white border border-gray-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Publish to Production */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Publish to Production</h3>
            </div>

            {/* Download Report Button */}
            <DownloadReportField status='pending' rawProductFeedValidationReportLocation='' />

            {/* Completion Message */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="flex items-center space-x-3">
                <CheckCircle className="h-6 w-6 text-green-600" />
                <div>
                  <h4 className="text-sm font-medium text-green-800">Production Deployment Complete</h4>
                  <p className="text-sm text-green-700 mt-1">Your product catalog is now live on production.</p>
                </div>
              </div>
            </div>

            {/* Back to Home Button */}
            <Button
              onClick={onBackToHome}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center gap-2"
            >
              Back to Home
            </Button>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Status:</span>
                <Badge className="bg-blue-100 text-blue-700">{stepNineTasks?.status || 'Pending'}</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Step9Completion; 